import axios from 'axios';

// Log the build environment
console.log('build env', process.env.BUILD_ENV);
const BASE_URL_PROD_VAR = 'https://platform.calyxglobal.com';
const BASE_URL_STAGING_VAR = 'https://platform.calyxstaging.com';
// const BASE_URL_STAGING_VAR = 'https://platform-ae95.calyxstaging.com';
// const BASE_URL_STAGING_VAR = 'https://dev2.calyxstaging.com';

const ASSET_BASE_URL_PROD_VAR = 'https://assets.calyxinternal.com';
const ASSET_BASE_URL_STAGING_VAR = 'https://staging-static.calyxinternal.com';

// Define the base URL based on the environment
export const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BUILD_ENV === 'prod'
      ? BASE_URL_PROD_VAR
      : process.env.REACT_APP_BASE_URL || BASE_URL_STAGING_VAR
    : BASE_URL_STAGING_VAR;

export const ASSET_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BUILD_ENV === 'prod'
      ? ASSET_BASE_URL_PROD_VAR
      : ASSET_BASE_URL_STAGING_VAR
    : ASSET_BASE_URL_STAGING_VAR;

// Create an Axios instance with the base URL and default headers
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

// Function to set the access token
export const setAccessToken = (accessToken) => {
  axiosInstance.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
};

export default axiosInstance;
